import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify'; // Import toast library

const ViewProfileLayer = () => {
    const [imagePreview, setImagePreview] = useState('assets/images/user-grid/user-grid-img13.png');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

    const [user, setUser] = useState(null);

    function EmailLink({ email }) {
        const handleCopyClick = () => {
            navigator.clipboard.writeText(email);
            toast.success('Email copied to clipboard!'); // Show success toast
        };

        return (
            <span
                onClick={handleCopyClick}
                style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
            >
                {email}
            </span>
        );
    }

    function EmailListItem({ email }) {
        return (
            <li className="d-flex align-items-center gap-1 mb-12">

                <span className="w-70 text-secondary-light fw-medium">
                    <EmailLink email={email} />
                </span>
            </li>
        );
    }

    // Load user details from localStorage
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    // Toggle function for password field
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    // Toggle function for confirm password field
    const toggleConfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };


    const readURL = (input) => {
        if (input.target.files && input.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setImagePreview(e.target.result);
            };
            reader.readAsDataURL(input.target.files[0]);
        }
    };
    const base64Image =
        "iVBORw0KGgoAAAANSUhEUgAAAAUA" +
        "AAAFCAYAAACNbyblAAAAHElEQVQI12P4" +
        "//8/w38GIAXDIBKE0DHxgljNBAAO" +
        "9TXL0Y4OHwAAAABJRU5ErkJggg==";
    return (
        <div className="row gy-4">
            <div className="col">
                <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">

                    <div className="pb-24 ms-16 mb-24 me-16  mt-60">
                        <div className="text-center border border-top-0 border-start-0 border-end-0">
                            <img
                                src={`${user?.picture}`}
                                alt=""
                                className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
                            />
                            <h6 className="mb-0 mt-16">{user?.name}</h6>
                            <span className="text-secondary-light mb-16">{user?.email}</span>
                        </div>
                        <div className="mt-24">
                            <h6 className="text-xl mb-16">Personal Info</h6>
                            <ul>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">
                                        Full Name
                                    </span>
                                    <span className="w-70 text-secondary-light fw-medium">
                                        : {user?.name}
                                    </span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">
                                        {" "}
                                        Email
                                    </span>
                                    <span className="w-70 text-secondary-light fw-medium">
                                        : {user?.email}
                                    </span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">
                                        {" "}
                                        Phone Number
                                    </span>
                                    <span className="w-70 text-secondary-light fw-medium">
                                        : {user?.mobile}
                                    </span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">
                                        Business Card
                                    </span>
                                    <span className="w-70 text-secondary-light fw-medium">
                                        {user?.businessCard ? (
                                            <img
                                                src={user.businessCard}
                                                alt="Business Card"
                                                style={{ maxWidth: '150px', maxHeight: '150px' }} // Adjust size as needed
                                            />
                                        ) : (
                                            "No Business Card" // Or some placeholder text/component
                                        )}
                                    </span>
                                </li>
                                <li className="d-flex align-items-center gap-1 mb-12">
                                    <span className="w-30 text-md fw-semibold text-primary-light">
                                        The Brokers Support Email for any queries
                                    </span>
                                    <span className="w-70 text-secondary-light fw-medium">
                                        <EmailListItem email="support@thebrokerz.com" />
                                    </span>
                                </li>


                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ViewProfileLayer;